'use strict';

define('TargetSelectView', ['backbone', 'NVTagCallbacks', 'SelectView', 'FieldView', 'autocomplete'],
function (Backbone, invokeCallbacks, SelectView, FieldView, autocomplete) {
  return SelectView.extend({
    __name__: 'TargetSelectView',
    initialize: function () {
      FieldView.prototype.initialize.call(this);
      this.template = this.options.templates.target_select;
    },
    render: function () {
      this.el.className = this.className();
      var def = this.def;

      var context = invokeCallbacks('alterContext', {element: this.type, def: def, context: {
        name: this.name,
        title: this.title,
        target: def.target,
        autocomplete: autocomplete('Prefix'),
        options: def.options
      }}).context;
      this.$el.html(this.template(context));
      this.setval(def.default_value);
      return this;
    },
    type: 'target_select'
  });
});

